import React from 'react'
import { Button, Icon } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import {
  selectDisplayStatus,
  selectSaleSyncStatus,
} from '../../../state/slices/currentSale/currentSaleSlice'
import {
  GIFT_RECEIPT_STATUSES,
  SaleSyncStatus,
} from '../../../models/sale.constants'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { usePrintReceipt } from './usePrintReceipt'

export const PrintButtons = () => {
  const printReceipt = usePrintReceipt()
  const syncStatus = useAppSelector(selectSaleSyncStatus)
  const displayStatus = useAppSelector(selectDisplayStatus)

  const disabled = syncStatus === SaleSyncStatus.UPLOAD_FIRST_SUBMIT

  const canPrintGiftReceipt =
    getFeatureFromCache('gift_receipts') &&
    displayStatus &&
    GIFT_RECEIPT_STATUSES.includes(displayStatus)

  const printGift = () => {
    printReceipt({ type: 'gift' })
  }

  return (
    <div className="vd-mt5 vd-btn-group">
      <Button
        onClick={() => printReceipt()}
        disabled={disabled}
        variant="supplementary"
        modifier="text"
        aria-label="Print default receipt"
        data-testid="printDefaultReceipt"
      >
        <Icon icon="fa-print" className="sale-summary-print-receipt-icon" />
        <span className="sale-summary-print-receipt-label">
          &nbsp;
          <T _str="Print" _context="Print receipt button label" />
        </span>
      </Button>
      {canPrintGiftReceipt && (
        <Button
          onClick={printGift}
          disabled={disabled}
          variant="supplementary"
          modifier="text"
          aria-label="Print gift receipt"
        >
          <Icon icon="fa-gift" className="sale-summary-print-receipt-icon" />
          <span className="sale-summary-print-receipt-label">
            &nbsp;
            <T _str="Gift receipt" _context="Print gift card receipt" />
          </span>
        </Button>
      )}
    </div>
  )
}
